import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export function setAdminToken(token) {
  if (token) {
    localStorage.setItem('msos_admin_token', token);
  } else {
    localStorage.removeItem('msos_admin_token');
  }
}

export function getAdminToken() {
  return localStorage.getItem('msos_admin_token');
}

export function adminHeaders() {
  const t = getAdminToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export function sessionHeaders(token) {
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export function apiError(e, fallback = 'Something went wrong. Please try again.') {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === 'string' ? x.msg : JSON.stringify(x))).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
}
